module.exports = __webpack_public_path__ + "img/1.f566b2d4.jpg";